// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__tdnPu","swipe":"Navigation_swipe__fqyop","btnFull":"Navigation_btnFull__2Zd6v","btn":"Navigation_btn__3ijVo"};